import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import PRODUCTS from '../data/products';

export default function ProductDetail({ onAddToCart }) {
  const { id } = useParams();
  const product = PRODUCTS.find((p) => p.id === id);
  const navigate = useNavigate();

  if (!product) {
    return <p>Product not found.</p>;
  }

  const handleAdd = () => {
    onAddToCart(product);
    navigate('/checkout');
  };

  return (
    <div className="page product-detail-page">
      <h1>{product.name}</h1>
      <img
        src={product.image}
        alt={product.name}
        style={{ maxWidth: '400px' }}
      />
      <p>{product.description}</p>
      <p>
        <strong>Price:</strong> ${product.price.toFixed(2)}
      </p>
      <h3>Specifications</h3>
      <ul>
        {Object.entries(product.specs).map(([k, v]) => (
          <li key={k}>
            <strong>{k}:</strong> {v}
          </li>
        ))}
      </ul>
      <button onClick={handleAdd}>Add to Cart & Checkout</button>
    </div>
  );
}
